<template>
  <v-container id="page-notice-detail">
    <div class="page-title mb-5">{{$route.name}}</div>
    <v-row justify="end">
      <c-btn color="blue" iconName="mdi-format-list-bulleted-square" outlined @click="onGetList()" class="mb-3 mr-2">목록으로</c-btn>
    </v-row>
    <c-card>
      <v-row align="center">
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-bold text--black subtitle-1">제 목</span>
        </v-col>
        <v-col cols="12" sm="6" md="10">
          <span v-if="checkedCritical()" class="mr-2"><v-icon color="red">warning</v-icon></span>
          <span class="font-weight-bold text--black subtitle-1">{{ this.noticeData.noticeTitle }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">작성일</v-col>
        <v-col cols="12" sm="6" md="4">{{ $func.dateTimeToString(this.noticeData.created) }}</v-col>
        <v-col cols="12" sm="6" md="2">수정일</v-col>
        <v-col cols="12" sm="6" md="4">{{ $func.dateTimeToString(this.noticeData.updated) }}</v-col>
      </v-row>
        <c-card outlined class="mt-2" style="min-height: 400px;">
          <!-- 내용 -->
          <div v-html="noticeData.noticeContents"></div>
        </c-card>
    </c-card>
    <v-row justify="start" class="mt-3 ml-2">
      <c-btn color="blue" outlined class="mr-1" iconName="edit" @click="onUpdateNotice()">수정</c-btn>
      <c-btn color="blue" outlined iconName="delete" @click="onDeleteNotice">삭제</c-btn>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        noticeData: {
          id: '',
          noticeTitle: '',
          noticeContents: '',
          criticalFlag: '',
          created: this.$func.curDateString(),
        },
      }
    },
    mounted() {
      const {noticeId} = this.$route.params;
      this.id = noticeId;
      this.reqNotice(noticeId);
    },
    methods: {
      async reqNotice(id) {
        try {
          const res = await this.$api.getNotice(id);
          this.noticeData = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqNotice'});
        }
      },
      checkedCritical() {
        return this.noticeData.criticalFlag === 'T';
      },
      onDeleteNotice() {
        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "공지 사항을 삭제하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteNotice(this.noticeData.id);
            }
          });

      },
      async reqDeleteNotice(id) {
        try {
          const res = await this.$api.deleteNotice(id);
          this.$store.commit('alert', {
            open: true, msg: "삭제가 완료되었습니다.",
            persistent: true,
            callBack: () => {
              this.$router.push('/noticeboard');
            }
          });
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqDeleteNotice'});
        }
      },
      onUpdateNotice() {
        this.$router.push(`/noticeWrite/${this.id}`);
      },
      onGetList() {
        this.$router.push(`/noticeboard`);
      }

    },
  }
</script>

<style scoped>

</style>